import { render, staticRenderFns } from "./VxTooltip.vue?vue&type=template&id=e96a4600"
import script from "./VxTooltip.vue?vue&type=script&lang=js"
export * from "./VxTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e96a4600')) {
      api.createRecord('e96a4600', component.options)
    } else {
      api.reload('e96a4600', component.options)
    }
    module.hot.accept("./VxTooltip.vue?vue&type=template&id=e96a4600", function () {
      api.rerender('e96a4600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/VxTooltip.vue"
export default component.exports